export default __webpack_public_path__ + "static/media/01_photo.f2cb0c61.jpg";